import Env from '@lib/Env';
import { Actor } from '@types';

export class PhotoModel implements Actor.Photo {
    id: number = null;
    hlas_id: number = null;
    state: string = null;
    file_mime: string = null;
    file_id: string = null;
    file_name: string = null;
    poradie: number = null;
    processed_at: number = null;
    created_at: number = null;
    updated_at: number = null;
    deleted_at: number = null;

    constructor({
        id,
        hlas_id,
        state,
        file_mime,
        file_id,
        file_name,
        poradie,
        processed_at,
        created_at,
        updated_at,
        deleted_at,
    }: Actor.Photo) {
        this.id = id;
        this.hlas_id = hlas_id;
        this.state = state;
        this.file_mime = file_mime;
        this.file_id = file_id;
        this.file_name = file_name;
        this.poradie = poradie;
        this.processed_at = processed_at;
        this.created_at = created_at;
        this.updated_at = updated_at;
        this.deleted_at = deleted_at;
    }

    get url() {
        return `${Env.services.storage.baseURL}/${this.file_id}`;
    }
}
